module.exports = __webpack_public_path__ + "img/pause.2ccd74be.svg";